import React from 'react';
import PropTypes from 'prop-types';

import { Collapsible, CollapsibleContent, CollapsibleContextConsumer, CollapsibleHeading } from '$partials/base/collapsible';
import { IconArrowDown, IconArrowUp } from '$partials/icons/index';
import ModuleDispatcher from '../dispatcher';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleAccordion = ({ title, items }) => {
    const modules = items?.items;

    return (
        <div className='bg-white relative'>
            <div className='layout-container'>
                <div className='w-full flex module-accordion'>
                    <div className='hidden md:block w-4/12 px-10 sm:px-5 md:px-10'/>
                    <Collapsible
                        className='w-full md:w-8/12 mb-20 px-10 sm:px-5 md:px-10'
                        id='directory-address-accordion'
                        isOpened={false}
                        key={`directory-address-accordion-${title}`}>
                        <CollapsibleHeading className='w-full pt-20 border-t border-dark-grey'>
                            <CollapsibleContextConsumer>
                                {({ isOpened }) => (
                                    <span className='flex items-center justify-between'>
                                        <p className='type-style-4 text-left w-10/12 sm:w-6/8 md:w-full mr-60'>{title}</p>
                                        <span
                                            aria-hidden='true'>
                                            <div className='text-white bg-orange-transition p-15 ml-5 flex rounded-button'>
                                                {isOpened ? <IconArrowUp/> : <IconArrowDown/>}
                                            </div>
                                        </span>
                                    </span>
                                )}
                            </CollapsibleContextConsumer>
                        </CollapsibleHeading>
                        <CollapsibleContent className='clearfix'>
                            {modules?.map((module, i) => {
                                return (
                                    <ModuleDispatcher
                                        isInAccordion={true}
                                        key={i}
                                        module={module}
                                        nextTypename={modules[i + 1]?.__typename}
                                        parentTypename={'BvaModuleAccordion'}
                                        previousTypename={modules[i - 1]?.__typename} />
                                );
                            })}
                        </CollapsibleContent>
                    </Collapsible>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleAccordion.propTypes = {
    items: PropTypes.object,
    title: PropTypes.string
};

export default ModuleAccordion;
